<div class="card card-statistics mb-30" >
  <div class="card-body">
    <h5 class="card-title">فرم ثبت اطلاعات مرخصی ساعتی</h5>
    <form [formGroup]="AddNewOfftime" (submit)="SubmitAddNewOfftime()">

      <input type="hidden" formControlName="id" />
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">از ساعت </label>

          <div class="row">
            <div class="form-group col-md-4">
              <select formControlName="startDate_Min" class="custom-select">
                <option value="{{item}}" *ngFor="let item of MinList">{{item}}</option>
              </select>
            </div> 
            :
            <div class="form-group col-md-4">
              <select formControlName="startDate_Hour" class="custom-select">
                <option value="{{item}}" *ngFor="let item of HourList">{{item}}</option>
              </select>
            </div>

          </div>

        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تا ساعت </label>
          <div class="row">
            <div class="form-group col-md-4">
              <select formControlName="endDate_Min" class="custom-select">
                <option value="{{item}}" *ngFor="let item of MinList">{{item}}</option>
              </select>
            </div> 
            :
            <div class="form-group col-md-4">
              <select formControlName="endDate_Hour" class="custom-select">
                <option value="{{item}}" *ngFor="let item of HourList">{{item}}</option>
              </select>
            </div>

          </div>

        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> تاریخ مد نظر </label>
          <input formControlName="requestDate" #vaziat_rerequestDateInput type="text" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="vaziat_rerequestDateInput"></ng-persian-datepicker>
        </div>


      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> شرح </label>
          <input formControlName="dsc" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_dsc().valid && get_Form_dsc().touched"
            class="form-text text-muted MyErrorRedColor">شرح را وارد نمائید.</small>
        </div>
      </div>
      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="submit"  [disabled]="!AddNewOfftime.valid" class="btn btn-success"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> تایید و ثبت اطلاعات </button>
      <button routerLink="/OffTime" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> بازگشت </button>
    </form>
  </div>
</div>



